import { useState } from "react";
import { SignRequest } from "@/services/backend/vbs/work-orders/api/work-order-api";
import { useDebouncedMutation } from "@/shared/lib/debounce/debounce";
import { SignatureDialog } from "@/services/backend/signature/components/signature-dialog";
import t from "@/lang/lang";
import { useHtzWorkOrderSignMutation } from "@/services/backend/htz/work-order/api/work-order-api";
import {
  useHasFieldErrors,
  useErrValidationFailedContext,
} from "@/shared/lib/errors/err-validation-failed-context";

export function SignatureButton(props: { workOrderId: string }) {
  const { workOrderId } = props;
  const [request, setRequest] = useState<SignRequest>({
    id: workOrderId,
    signature: "",
    dataFormat: "image/svg+xml:base64",
    nameOfSigner: "",
  });
  const mutation = useHtzWorkOrderSignMutation();

  // it was easier to use debounce to update the persistence state context
  useDebouncedMutation(
    request,
    setRequest,
    mutation,
    {
      id: workOrderId,
      signature: "",
      dataFormat: "image/svg+xml:base64",
      nameOfSigner: "",
    },
    { delay: 0 },
  );

  // "signatureId" is reported by the readiness check of the work order,
  // "signature" by the sign request.
  const { hasErrors: hasSigErr } = useHasFieldErrors([
    "signatureId",
    "signature",
  ]);
  const { resetField } = useErrValidationFailedContext();

  return (
    <div className={hasSigErr ? "border-destructive rounded-md border" : ""}>
      <SignatureDialog
        title={t("Arbeitsschein bestätigen")}
        name=""
        onConfirm={(data) => {
          setRequest({
            ...request,
            signature: data.signature,
            nameOfSigner: data.name,
          });
          resetField("signatureId");
          resetField("signature");
        }}
      />
    </div>
  );
}
